/**
 * Deferred Klaviyo Back-in-Stock Initialization
 * Loads Klaviyo SDK and initializes back-in-stock functionality
 * Performance optimized: deferred loading to not block rendering
 */

function initKlaviyo(config) {
  // Check if Klaviyo SDK is loaded
  if (typeof klaviyo === 'undefined') {
    console.warn('Klaviyo SDK not loaded yet, retrying...');
    setTimeout(function() { initKlaviyo(config); }, 100);
    return;
  }

  // Initialize Klaviyo
  klaviyo.init({
    account: config.account,
    platform: "shopify"
  });

  // Enable back-in-stock functionality
  klaviyo.enable("backinstock", config.backInStockSettings);
}

// Auto-init when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function() {
    if (window.klaviyoConfig) {
      initKlaviyo(window.klaviyoConfig);
    }
  });
} else {
  // DOM already loaded
  if (window.klaviyoConfig) {
    initKlaviyo(window.klaviyoConfig);
  }
}
